import React from 'react';
import { NewspaperIcon, PlayIcon, BookOpenIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const MediaInsights = () => {
  const mediaItems = [{
    id: 1,
    title: 'The Truth About Probiotics: Separating Science from Marketing',
    type: 'Article',
    date: 'August 15, 2023',
    image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#article-1',
    icon: <NewspaperIcon size={20} className="mr-2" data-id="element-864" data-mp="y54pjo22lw2l" />
  }, {
    id: 2,
    title: 'Microbiome Research Explained: Interview with Azn Alahah',
    type: 'Video',
    date: 'July 28, 2023',
    image: 'https://images.unsplash.com/photo-1551817958-d9d86fb29431?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#video-1',
    icon: <PlayIcon size={20} className="mr-2" data-id="element-865" data-mp="14qy7yj8o72k1" />
  }, {
    id: 3,
    title: 'How Diet Affects Your Microbiome: New Research Findings',
    type: 'Article',
    date: 'June 12, 2023',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#article-2',
    icon: <NewspaperIcon size={20} className="mr-2" data-id="element-866" data-mp="m0zz40x1t5fc" />
  }, {
    id: 4,
    title: "Ukweli Institute's Guide to Microbiome Testing",
    type: 'Guide',
    date: 'May 30, 2023',
    image: 'https://images.unsplash.com/photo-1576671414121-aa0c81c869e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#guide-1',
    icon: <BookOpenIcon size={20} className="mr-2" data-id="element-867" data-mp="26fjvseck1wo7" />
  }];
  return <section id="media" className="py-16 bg-gray-50" data-id="element-868" data-mp="22f9fo8v1tpvm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-869" data-mp="22frhrm4e6ybg">
        <div className="text-center mb-12" data-id="element-870" data-mp="3vxgtqktj1b0t">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-871" data-mp="3vvm5oxmyl2si">
            Media & Insights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-872" data-mp="3mx0rtfsfmby2">
            Stay informed with our latest articles, videos, and educational
            resources
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-873" data-mp="3qw9lkknh29tm">
          {mediaItems.map((item, index) => <div key={item.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col md:flex-row" data-id="element-874" data-mp="nhna3x3wfjfj" data-mpi={index}>
              <div className="md:w-2/5 h-48 md:h-auto relative" data-id="element-875" data-mp="egyw32ei9j2n">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80';
            }} data-id="element-876" data-mp="ejbl1zioktp7" />
                {item.type === 'Video' && <div className="absolute inset-0 flex items-center justify-center" data-id="element-877" data-mp="30p51jgenhdfo">
                    <div className="bg-blue-600/80 rounded-full p-3 text-white" data-id="element-878" data-mp="2vpilz0bcnl3p">
                      <PlayIcon size={24} data-id="element-879" data-mp="2vnpgvpgdx8xt" />
                    </div>
                  </div>}
              </div>
              <div className="p-6 md:w-3/5 flex flex-col justify-between" data-id="element-880" data-mp="231d3kk7rq871">
                <div data-id="element-881" data-mp="22z0eln3lexkh">
                  <div className="flex items-center mb-2" data-id="element-882" data-mp="2hq99aamcr94h">
                    {item.icon}
                    <span className="text-sm font-semibold text-blue-600" data-id="element-883" data-mp="2czaoaxqf5muw">
                      {item.type}
                    </span>
                    <span className="mx-2 text-gray-400" data-id="element-884" data-mp="1p85aeo41h4n8">•</span>
                    <span className="text-sm text-gray-500" data-id="element-885" data-mp="1kan2n11rcvgt">{item.date}</span>
                  </div>
                  <h3 className="font-bold text-lg mb-2 text-gray-900" data-id="element-886" data-mp="nji5vedfac4q">
                    {item.title.includes('Azn Alahah') ? <>
                        {item.title.split('Azn Alahah')[0]}
                        <Link to="/profile" className="text-blue-600 hover:text-blue-800" data-id="element-887" data-mp="wiloyiclarj8">
                          Azn Alahah
                        </Link>
                        {item.title.split('Azn Alahah')[1]}
                      </> : item.title}
                  </h3>
                </div>
                <Link to={item.link} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium mt-4 text-sm" data-id="element-888" data-mp="1g5jb0lx7tdog">
                  Read more <ArrowRightIcon size={16} className="ml-1" data-id="element-889" data-mp="3i13kd6vv1w3r" />
                </Link>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-10" data-id="element-890" data-mp="3ehcsdzfyvqcs">
          <Link to="/media" className="inline-flex items-center bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 px-6 rounded-md transition-colors duration-200" data-id="element-891" data-mp="3eie84h7xh10u">
            View all resources <ArrowRightIcon size={16} className="ml-2" data-id="element-892" data-mp="30q7zdg73twbf" />
          </Link>
        </div>
      </div>
    </section>;
};